import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { computed, ref } from 'vue';
import ManagementPlanItem from '@/lib/components/ManagementPlan/ManagementPlanItem.vue';
import { MedKitFieldLabel, MedKitButton } from '@bigpicturemedical/medkit';
import { IPlanItem } from '@/models';
import { IErrors } from '@/lib';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementPlanItemRepeater',
  props: {
    title: {},
    errors: {}
  },
  emits: ["update:plan-items"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const planItems = ref<Array<Partial<IPlanItem> | IPlanItem>>([]);
const repeaterKey = ref<number>(1);
const validationErrors = computed(() => props.errors ?? null);

const addPlanItem = () => {
  planItems.value.push({});
};

const removePlanItem = (index: number) => {
  validationErrors.value?.splice(index, 1);
  repeaterKey.value += 1;
  planItems.value.splice(index, 1);
  updatePlanItems(planItems.value);
};

const updatePlanItems = (planItems: Partial<IPlanItem>[]) => {
  emit('update:plan-items', planItems);
};

const handleConsultTypeUpdate = (event, index, item) => {
  delete validationErrors.value?.[index]?.consult_type;
  item.consult_type = event;
  planItems.value[index] = item;
  updatePlanItems(planItems.value);
};

const handleClinicianTypeUpdate = (event, index, item) => {
  delete validationErrors.value?.[index]?.clinician_type;
  item.clinician_type = event;
  planItems.value[index] = item;
  updatePlanItems(planItems.value);
};

const handleConsultInChange = (event, index, item) => {
  delete validationErrors.value?.[index]?.date_of_consult_in;
  item.consult_in_digit = event.digit;
  item.consult_in_unit = event.unit;
  item.consult_in = `${event.digit} ${event.unit}`;
  item.date_of_consult_in = event.date;
  planItems.value[index] = item;
  updatePlanItems(planItems.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.title)
      ? (_openBlock(), _createBlock(_unref(MedKitFieldLabel), {
          key: 0,
          label: _ctx.title,
          for: "plan-item",
          class: "mb-0"
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planItems.value, (item, index) => {
      return (_openBlock(), _createBlock(ManagementPlanItem, {
        key: `${repeaterKey.value}-${index}`,
        name: "plan-item",
        class: "mt-3",
        "data-dusk": `plan-item-${index}`,
        "plan-item": item,
        errors: validationErrors.value?.[index],
        onDelete: ($event: any) => (removePlanItem(index)),
        "onUpdate:consultType": ($event: any) => (handleConsultTypeUpdate($event, index, item)),
        "onUpdate:clinicianType": ($event: any) => (handleClinicianTypeUpdate($event, index, item)),
        "onChange:consultIn": ($event: any) => (handleConsultInChange($event, index, item))
      }, null, 8, ["data-dusk", "plan-item", "errors", "onDelete", "onUpdate:consultType", "onUpdate:clinicianType", "onChange:consultIn"]))
    }), 128)),
    _createVNode(_unref(MedKitButton), {
      label: _ctx.$t('custom.uhb.review.add-plan-item'),
      icon: "plus",
      "icon-position": "start",
      size: "medium",
      kind: "repeater",
      class: "w-full mt-3",
      "data-dusk": "add-plan-item-button",
      onClick: addPlanItem
    }, null, 8, ["label"])
  ]))
}
}

})